<template>
  <v-alert type="error">{{ getErrorDesc }}
    <ul class="pl-0">
      <li v-for="(error, index) of getErrors" :key="index">{{ getErrorMessage(error) }}</li>
    </ul>
  </v-alert>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      required: true
    },
    messageKey: {
      type: String,
      required: true
    },
    scroll: {
      type: Boolean,
      default: true
    },
    replaceList: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({}),
  computed: {
    getErrorDesc () {
      let result = ''
      if (this.$route.path.startsWith('/admin')) {
        result = this.$i18n.t('message.error.desc.errorDesc', 'ja')
      } else {
        result = this.$i18n.t('message.error.desc.errorDesc')
      }
      return result
    },
    getErrors () {
      // 「エラーが設定された場合」かつ「スクロール実施のフラグ（scrollがtrue）の場合」に画面トップに移動
      if (this.errors.length > 0 && this.scroll) window.scrollTo(0, 0)
      return this.errors
    }
  },
  methods: {
    getErrorMessage (error) {
      let locale = ''
      if (this.$route.path.startsWith('/admin')) {
        locale = 'ja'
      } else {
        locale = this.$i18n.locale
      }

      let message = this.$i18n.t(this.messageKey + error.param + '.' + error.msg, locale)

      for (const replace of this.replaceList) {
        if (replace.param === error.param) {
          message = message.replace(replace.pattern, replace.replacement[locale])
        }
      }

      return message
    }
  }
}
</script>

<style scoped>
</style>
